// SearchForm.js

import React, { useState, useRef, useEffect } from "react";

const SearchForm = ({
  onSearch,
  placeholder = "Search...",
  initialValue = "",
  resetKey = 0,
}) => {
  const [searchTerm, setSearchTerm] = useState(initialValue);
  const searchInput = useRef(null);

  useEffect(() => {
    searchInput.current.focus();
  }, []);

  // This effect will reset the search term when resetKey changes
  useEffect(() => {
    setSearchTerm(initialValue);
  }, [initialValue, resetKey]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSearch(searchTerm);
  };

  return (
    <form onSubmit={handleSubmit} className="mb-4 flex space-x-2">
      <input
        ref={searchInput}
        type="text"
        className="p-2 border rounded flex-grow"
        placeholder={placeholder}
        value={searchTerm}
        onChange={handleSearchChange}
      />
      <button
        type="submit"
        className="px-4 py-2 bg-blue-500 text-white rounded"
      >
        Search
      </button>
    </form>
  );
};

export default SearchForm;
